/**
 * Super-admin ("Mika Ops") token storage.
 *
 * Intentionally in sessionStorage (not localStorage):
 *  - dies when the tab closes — critical on shared machines
 *  - isolated from the tenant tenant app's `mikaBearerToken` in localStorage
 *  - separate key namespace prevents any accidental cross-contamination
 */

const KEY = 'sa_access_token';

export function getSuperAdminToken(): string | null {
    try {
        return sessionStorage.getItem(KEY);
    } catch (e) {
        return null;
    }
}

export function setSuperAdminToken(token: string): void {
    try {
        sessionStorage.setItem(KEY, token);
    } catch (e) {
        // sessionStorage can throw in rare privacy-mode configurations; surface silently.
    }
}

export function clearSuperAdminToken(): void {
    try {
        sessionStorage.removeItem(KEY);
    } catch (e) {
        // noop
    }
}

export function hasSuperAdminToken(): boolean {
    return !!getSuperAdminToken();
}
